import axios from "axios";
import { useEffect, useRef, useState } from "react";
import LoadingIcon from "../../../../../../../../../../../../../../Assets/Icons/circular-determinate.svg";
import ExitFullScreenIcon from "../../../../../../../../../../../../../../Assets/Icons/close-square.svg";
import EnterFullScreenBlackIcon from "../../../../../../../../../../../../../../Assets/Icons/full-screen-black.svg";

const Image = (props) => {
  const [Src, setSrc] = useState(null);
  const [loading, setLoading] = useState(props.ShowLoading);

  const imgRef = useRef(null);

  const handleImageLoaded = () => {
    setLoading(false);
  };

  const handleImageError = () => {
    setLoading(false);
  };

  useEffect(() => {
    const fetchImage = async () => {
      let Req = {
        method: "GET",
        url: props.ImageURL,
        responseType: "arraybuffer", // Ensure the response is in array buffer format
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
        },
      };
      try {
        const Res = await axios(Req);
        const imageData = Res.data;
        const blob = new Blob([imageData], { type: "image/jpeg" }); // Adjust the MIME type if necessary
        const url = URL.createObjectURL(blob);
        setSrc(url);
      } catch (Err) {
        console.error("Error fetching image:", Err);
      }
    };

    if (isValidUrl(props.ImageURL)) {
      fetchImage();
    }
  }, [props.ImageURL]);

  // Helper function to validate URL
  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <div style={{ position: "relative" }}>
      {props.isZoomed && (
        <div
          style={{
            position: "fixed",
            height: "100%",
            width: "100%",
            top: 0,
            left: 0,
            zIndex: 99,
          }}
          onClick={() => props.setIsZoomed(false)}
        >
          <div
            style={{
              backgroundColor: "#d9d9d9b3",
              position: "absolute",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {props.isMobile && (
              <img
                src={Src}
                ref={imgRef}
                alt=""
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
                onClick={stopPropagation}
              />
            )}
          </div>
          {props?.canZoom && props.isZoomed && (
            <img
              src={ExitFullScreenIcon}
              style={{
                position: "absolute",
                top: 20,
                right: 20,
                width: 40,
                height: 40,
                cursor: "pointer",
              }}
              alt="Exit Full Screen"
              onClick={() => props.setIsZoomed((prev) => !prev)}
            />
          )}
        </div>
      )}
      <img
        src={props?.src || Src}
        ref={props.ref ? props.ref : imgRef}
        className={props.className}
        alt=""
        onLoad={handleImageLoaded}
        onError={handleImageError}
        onClick={props?.onClick}
        style={{
          transition: "transform 0.3s ease-in-out, opacity 0.4s ease-in-out",
          opacity: props?.hasOpacityAnimation ? 0 : 1,
          ...(props.isZoomed && !props.isMobile
            ? {
                position: "sticky",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%) scale(1.5)",
                zIndex: 100,
                opacity: 1,
              }
            : {}),
          ...(props.Style ? props.Style : {}),
        }}
      />
      {props.isMobile && !props.isZoomed && props.canZoom && (
        <img
          src={EnterFullScreenBlackIcon}
          alt=""
          style={{
            position: "absolute",
            top: 5,
            right: "6%",
          }}
          onClick={() => props.setIsZoomed(true)}
        />
      )}
      {props.ShowLoading && loading && (
        <div className="loading-icon-small-container">
          <img alt="" className="loading-icon-small" src={LoadingIcon} />
        </div>
      )}
    </div>
  );
};

export default Image;
